import React from "react";
import {
  ChangedFields,
  CommentSummaryProps,
} from "./types/workOrderActivityTypes";
import { ActivityTypeEnum } from "./enums/workOrderActivity.enums";
import { Box, Typography } from "@mui/material";
import { fieldDisplayNames } from "./records/activityPropsRecordsUtility";

const CommentActivityView = ({
  changedFieldsJson,
  state,
}: CommentSummaryProps) => {
  let parsed: ChangedFields;

  try {
    parsed = JSON.parse(changedFieldsJson);
  } catch (error) {
    return <div>Invalid change data</div>;
  }

  return (
    <Box
      ml={"5px"}
      sx={{
        border: "1px solid lightgray",
        padding: "5px",
        borderRadius: "5px",
        background: (theme) =>
          theme.palette.mode === "light" ? "#f7f5f5" : "#181F2A",
        boxShadow: 2,
      }}
    >
      {Object.entries(parsed).map(([entity, fields]) => (
        <Box key={entity} mb={2}>
          {Object.entries(fields).map(([fieldName, values]) => {
            const displayName = fieldDisplayNames[fieldName] || fieldName; // fallback to fieldName
            return (
              <Typography variant="body2" key={fieldName}>
                {state === ActivityTypeEnum.INSERT ? (
                  <>
                    <em>"{values.newValue || "empty"}"</em>
                  </>
                ) : (
                  <>
                    <strong>{displayName}</strong> was updated from{" "}
                    <em>"{values.old || "empty"}"</em> to{" "}
                    <em>"{values.newValue || "empty"}"</em>
                  </>
                )}
              </Typography>
            );
          })}
        </Box>
      ))}
    </Box>
  );
};

export default CommentActivityView;
